import { render } from "./ModalReservarOla.vue?vue&type=template&id=01a4f368"
import script from "./ModalReservarOla.vue?vue&type=script&lang=js"
export * from "./ModalReservarOla.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__